import { ModuleTypeFamily, ModuleTypeId } from "../../types/DBTables";
import { IGlobalData, NormalårstemperaturInfo, Verksamhet, Värmekälla, kommunInfo } from "../../types/globalData";
import { IRound } from "../roundHandler";
import { IModuleByggnadsdata, IModuleLokalerRound, StickProv, TemperaturInfoByggnad, TemperaturInfoStickprov } from "../../types/ModuleDatas";
import { IJ3_FTX_FT_BFData } from "../../types/BFDatas";
import { logAndNotifyError } from "../logger";

export interface IBIMHandler {
  getGradtimmarKyla(kontrollmättTempRegTilluft: number): number;
  getVerkningsgradFromVärmeBatterityp(värmeBatteriSystemtyp: string): number;
  G5_kommun: string;
  G13_ÅrligBruttoAnvändningCentralVärme: () => number;
  BIM_ÅrligBruttoTransmission: () => number;
  G15_BruttoAnvändningTransmission: () => number;
  G17_BruttoEnergiVentilation_FTX: () => number;
  G17_BruttoEnergiVentilation_FX: () => number;
  G17_BruttoEnergiVentilation_s: () => number;
  G17_BruttoEnergiVentilation: () => number;
  G19_BruttoEnergiTappvatten: number;
  BIM_Vägledande_VerkninsgradAktuellVärmekälla: number;
  BIM_Vägledande_Energitäckningsgrad_Värmekälla: number;
  G11_GeografiskJusteringsFaktor: number | undefined;
  kommun: string;
  byggnadArea: number;
  nybyggnadsar: string;
  verksamhet: string;
  verksamhetInfo?: Verksamhet;
  energiKälla: string;
  energiSlag: string;
  värmeKällaInfo?: Värmekälla;
  normalårsTemperaturOmråde: string;
  normalårsTemperatur: number;
  allaZoner: string[];
  allaVärmeSystem: string[];
  allaVentilationsSystem: string[];
  getStickprovsMätningarFörVärmesystem: (modName: string) => StickProv[];
  getModuleTemperatureInfo: (modName: string) => { tempInfo: TemperaturInfoByggnad; stickprov: TemperaturInfoStickprov } | undefined;
  BIM_Pumpstopp_UteTemperatur: number;
  BIM_Schablon_TempOptimeratPumpstopp: number;
  BIM_Schablon_EnergiKyla: number;
  BIM_NormalUppvärmningstemperatur: number;
  BIM_DensitetLuft: number;
  BIM_Luft_Energimängd: number;
  BIM_TimmarPerGrad_Värme: number;
  BIM_GradtimmarVärmeFörOrten: number;
  BIM_Gradtimmar_Kyla_Orten: number;
  BIM_BruttoCentralVärme_Ventilation: () => number;
  BIM_Brutto_LokalVärmekälla_Ventilation: () => number;
  BIM_MedelAvkylning_FJV_SWE: number;
  BIM_QWtal_FJV_SWE: number;
  BIM_FlödesTaxa_Kr_m3: number;
}

export const getBIMHandler = (globalData: IGlobalData, round: IRound, buildingId: number): IBIMHandler => {
  const modByggnadsData = round.data.modules.find((m) => m.moduleTypeId === ModuleTypeId.Byggnadsdata);
  // let modByggnadsData : IModuleRound | undefined = undefined;
  // try{
  //   modByggnadsData = round.data.modules.find((m) => m.moduleTypeId === ModuleTypeIds.Byggnadsdata);
  // }
  const dbgRound = round;
  //const modByggnadsDataData: IModuleByggnadsdata = modByggnadsData?.data;
  const info = {
    get modByggnadsDataData() {
      return modByggnadsData?.data as IModuleByggnadsdata;
    },
  };

  if (!globalData)
    return {
      G13_ÅrligBruttoAnvändningCentralVärme: () => 1,
      BIM_ÅrligBruttoTransmission: () => 1,
      G15_BruttoAnvändningTransmission: () => 1,
      G17_BruttoEnergiVentilation_FTX: () => 1,
      G17_BruttoEnergiVentilation_FX: () => 1,
      G17_BruttoEnergiVentilation_s: () => 1,
      G17_BruttoEnergiVentilation: () => 1,
      G19_BruttoEnergiTappvatten: 1,
      BIM_Vägledande_VerkninsgradAktuellVärmekälla: 1,
      BIM_Vägledande_Energitäckningsgrad_Värmekälla: 1,
      G11_GeografiskJusteringsFaktor: 1,
      getVerkningsgradFromVärmeBatterityp: (s: string) => 1,
      getGradtimmarKyla: (n: Number) => 3600,
      G5_kommun: "",
      kommun: "",
      byggnadArea: 1,
      nybyggnadsar: "?",
      verksamhet: "?",
      verksamhetInfo: undefined,
      energiKälla: "?",
      värmeKällaInfo: undefined,
      energiSlag: "?",
      normalårsTemperatur: 1,
      normalårsTemperaturOmråde: "?",
      allaZoner: [],
      allaVärmeSystem: [],
      allaVentilationsSystem: [],
      getStickprovsMätningarFörVärmesystem: () => [],
      BIM_Pumpstopp_UteTemperatur: 21,
      BIM_Schablon_TempOptimeratPumpstopp: 17,
      BIM_Schablon_EnergiKyla: 2,
      BIM_NormalUppvärmningstemperatur: 18,
      BIM_DensitetLuft: 1.25,
      BIM_Luft_Energimängd: 1.005,
      BIM_TimmarPerGrad_Värme: 7400,
      BIM_GradtimmarVärmeFörOrten: 69560,
      BIM_Gradtimmar_Kyla_Orten: 3600,
      BIM_BruttoCentralVärme_Ventilation: () => 0,
      BIM_Brutto_LokalVärmekälla_Ventilation: () => 0,
      BIM_MedelAvkylning_FJV_SWE: 36,
      BIM_QWtal_FJV_SWE: 24,
      BIM_FlödesTaxa_Kr_m3: 4,
      getModuleTemperatureInfo: (modName: string) => undefined,
    };

  const kommun = info.modByggnadsDataData.kommun as string;
  const byggnadArea = info.modByggnadsDataData.byggnadArea as number;
  const nybyggnadsar = info.modByggnadsDataData.nybyggnadsår as string;
  const verksamhet = info.modByggnadsDataData.verksamhet;
  const energiKälla = info.modByggnadsDataData.energikälla as string;

  const energiKällaDataRow = globalData?.Byggnadsdata?.Värmekälla.find((r) => r.Värmekälla === energiKälla);
  const G29_VägledandeVerkningsgradVärmekälla = energiKällaDataRow?.COP as number;
  const G31_VägledandeEnergitäckningsgradVärmekälla = energiKällaDataRow?.Energitäckningsgrad as number;
  const energiSlag = energiKällaDataRow?.Energislag as string;

  const G5_kommun = kommun;
  const kommunDataRow = globalData?.Gemensamt?.kommunInfo?.find((ki) => ki.Kommun === kommun) as kommunInfo;
  const G11_GeografiskJusteringsFaktor = kommunDataRow?.Fgeo;
  const normalårsTemperatur = kommunDataRow["Normalårs-temperatur"];
  const normalårsTemperaturInfoRow = globalData.Gemensamt.normalårstemperaturInfo.find((r) => r.NormalårsTemperatur === normalårsTemperatur) as NormalårstemperaturInfo;
  const normalårsTemperaturOmråde = normalårsTemperaturInfoRow.Tabellområde;
  const BIM_TimmarPerGrad_Värme = normalårsTemperaturInfoRow.TimmarPerGradUppvärmning;

  const allaVarmeModuler = round.data.modules.filter(
    (m) => m.family === ModuleTypeFamily.VärmeEl || m.family === ModuleTypeFamily.VärmePrimar || m.family === ModuleTypeFamily.VärmeSekundar
  );
  const allaVarmeSystemNamn = allaVarmeModuler.map((m) => m.name);
  const allaBetjäningsområden = allaVarmeModuler.filter((m) => m.data.betjäningsområde).map((m) => m.data.betjäningsområde);

  const allaVentilationsModuler = round.data.modules.filter((m) => m.family === ModuleTypeFamily.Ventilation);
  const allaVentilationsSystemNamn = allaVentilationsModuler.map((m) => m.name);

  // const modByggnadsDataDataInklRound = () => {
  //   const modByggnadsData = round.data.modules.find((m) => m.moduleTypeId === ModuleTypeIds.Byggnadsdata);

  // return modByggnadsData?.data ? JSON.parse(modByggnadsData.data) : undefined;
  // }

  const G13_ÅrligBruttoAnvändningCentralVärme = () => {
    const v = G29_VägledandeVerkningsgradVärmekälla ? info.modByggnadsDataData.årligVärmeFörbrukning * G29_VägledandeVerkningsgradVärmekälla : 0;
    return v;
  };

  const G17_BruttoEnergiVentilation_FTX = () => {
    let sum = 0;
    round.data.modules.forEach((m) => {
      //TODO! Fixa när Ventilation FX och S är klara!
      if (m.moduleTypeId === ModuleTypeId.VentilationFTX || m.moduleTypeId === ModuleTypeId.VentilationFT) {
        const bflJ3 = m.bfs.BFL_J3_FTX_FT;
        if (bflJ3 && bflJ3.data?.export?.energiAnvCentralUppvärmning) sum += bflJ3.data.export.energiAnvCentralUppvärmning;
      }
    });

    return sum;
  };
  const G17_BruttoEnergiVentilation_FX = () => {
    let sum = 0;
    round.data.modules.forEach((m) => {
      if (m.moduleTypeId === ModuleTypeId.VentilationFX || m.moduleTypeId === ModuleTypeId.VentilationF) {
        const bflJ3 = m.bfs.BFL_J3_FX_F;
        if (bflJ3 && bflJ3.data?.export?.årligEnergiFörlust) sum += bflJ3.data.export.årligEnergiFörlust;
      }
    });

    return sum;
  };
  const G17_BruttoEnergiVentilation_s = () => {
    let sum = 0;
    round.data.modules.forEach((m) => {
      if (m.moduleTypeId === ModuleTypeId.VentilationS) {
        const bflJ3 = m.bfs.BFL_J3_S;
        if (bflJ3 && bflJ3.data?.export?.årligEnergiAnvändning) sum += bflJ3.data.export.årligEnergiAnvändning;
      }
    });

    return sum;
  };

  const G17_BruttoEnergiVentilation = () => {
    //todo!! Summera över all ventilations-moduler (bfs).
    //Aktuell energianvändning uppvärmning / år för ventilationsaggregat.
    // Här skall aktuell energianvändning (värme) summeras för varje ventilationsaggregat som använder CENTRALT framställd värme.
    // Exempel 1: Hämta värde i flik BFL J1 FTX
    // Cellbeskrivning: Aktuell energianvändning uppvärmning / år för ventilationsaggregat. (KWh/år) -> BIM
    // För BFL J3 FTX-FT hämtas värde från cell B33. (ftxenergianvändningUppvärmningFörVentialtion)

    //return 32297.4036;
    //return 178745;
    let sum = 0;

    //Ifall summan av alla ventilationsaggregat som använder centralvärme är större äm 50% av Årlig brutto användning centralvärme
    //så begränsas summan till hälften av Årlig brutto användning centralvärme.
    const begränsningIfallÅrligBrutto = G13_ÅrligBruttoAnvändningCentralVärme() / 2;
    round.data.modules.forEach((m) => {
      if (m.moduleTypeId === ModuleTypeId.VentilationFTX || m.moduleTypeId === ModuleTypeId.VentilationFT) {
        const bflJ3 = m.bfs.BFL_J3_FTX_FT;
        if (bflJ3 && bflJ3.data?.export?.energiAnvCentralUppvärmning) sum += bflJ3.data.export.energiAnvCentralUppvärmning;
      }
      if (m.moduleTypeId === ModuleTypeId.VentilationFX || m.moduleTypeId === ModuleTypeId.VentilationF) {
        const bflJ3 = m.bfs.BFL_J3_FX_F;
        if (bflJ3 && bflJ3.data?.export?.årligEnergiFörlust) sum += bflJ3.data.export.årligEnergiFörlust;
      }
      if (m.moduleTypeId === ModuleTypeId.VentilationS) {
        const bflJ3 = m.bfs.BFL_J3_S;
        if (bflJ3 && bflJ3.data?.export?.årligEnergiAnvändning) sum += bflJ3.data.export.årligEnergiAnvändning;
      }
    });

    sum = Math.min(sum, begränsningIfallÅrligBrutto);

    return sum;
  };

  const BIM_BruttoCentralVärme_Ventilation = G17_BruttoEnergiVentilation;
  const BIM_Brutto_LokalVärmekälla_Ventilation = () => {
    let sum = 0;
    round.data.modules.forEach((m) => {
      if (m.moduleTypeId === ModuleTypeId.VentilationFTX || m.moduleTypeId === ModuleTypeId.VentilationFT) {
        const bflJ3 = m.bfs.BFL_J3_FTX_FT;
        if (bflJ3 && bflJ3.data?.export) {
          const bflData = bflJ3.data as IJ3_FTX_FT_BFData;
          //=IF('BFL J3 FTX-FT'!B33<'BFL J3 FTX-FT'!B30;'BFL J3 FTX-FT'!B30;0)
          if (bflData.export.energiAnvCentralUppvärmning < bflData.export.energiAnvVentilationBrutto) sum += bflData.export.energiAnvVentilationBrutto;
        }
      }
    });

    return sum;
  };
  const GIN_D16_producerarTappVarmvatten = info.modByggnadsDataData.producerarTappvarmvatten === "Ja";

  const verksamhetDataRow = globalData.Byggnadsdata.Verksamhet.find((r) => r.Verksamhet === verksamhet);
  const G19_BruttoEnergiTappvatten = GIN_D16_producerarTappVarmvatten ? (verksamhetDataRow?.NyckeltalEnergi || 0) * info.modByggnadsDataData.byggnadArea : 0;

  const G15_BruttoEnergiTransmission = () => {
    let g13 = G13_ÅrligBruttoAnvändningCentralVärme() as number;
    g13 = g13 || 0;
    let g19 = G19_BruttoEnergiTappvatten as number;
    g19 = g19 || 0;
    const g17 = G17_BruttoEnergiVentilation();
    return g13 - g19 - g17;
  };

  const modLokaler = round.data.modules.find((m) => m.moduleTypeId === ModuleTypeId.Lokaler);
  const infoLokaler = {
    get Data() {
      return modLokaler?.data as IModuleLokalerRound;
    },
  };

  const getStickprovsMätningarFörVärmesystem = (modName: string) => {
    const myArrStickprov = infoLokaler.Data.stickprov ? infoLokaler.Data.stickprov.filter((sp) => sp.värmeSystem === modName) : [];
    return myArrStickprov;
  };

  const BIM_Pumpstopp_UteTemperatur = globalData.System.mapSystemParametrar.BIM_Pumpstopp_UteTemperatur;
  const BIM_Schablon_TempOptimeratPumpstopp = globalData.System.mapSystemParametrar.BIM_Schablon_TempOptimeratPumpstopp;
  const BIM_Schablon_EnergiKyla = verksamhetDataRow ? verksamhetDataRow.SchablonEnergiKyla : 2; // globalData.System.mapSystemParametrar.BIM_Schablon_EnergiKyla;

  const BIM_NormalUppvärmningstemperatur = globalData.System.mapSystemParametrar.BIM_NormalUppvärmningstemperatur;
  const BIM_DensitetLuft = globalData.System.mapSystemParametrar.BIM_DensitetLuft;
  const BIM_Luft_Energimängd = globalData.System.mapSystemParametrar.BIM_Luft_Energimängd;

  const BIM_GradtimmarVärmeFörOrten = (BIM_NormalUppvärmningstemperatur - normalårsTemperatur) * BIM_TimmarPerGrad_Värme; //=(BIM_NormalUppvärmningstemperatur-BIM_NormalårsTemperatur)*BIM_TimmarPerGrad_Värme

  const gradTimmarKylaRow = globalData.Gemensamt.gradtimmarKylaPerTabellområdeOchTempTilluft.find(
    (r) => r.Tabellområde === normalårsTemperaturOmråde && r.TempTilluft === BIM_NormalUppvärmningstemperatur
  );

  const BIM_Gradtimmar_Kyla_Orten = gradTimmarKylaRow ? gradTimmarKylaRow.GradtimmarKyla : 0;

  const BIM_MedelAvkylning_FJV_SWE = globalData.System.mapSystemParametrar.BIM_MedelAvkylning_FJV_SWE;
  const BIM_QWtal_FJV_SWE = 1 / (BIM_MedelAvkylning_FJV_SWE / 880);
  const BIM_FlödesTaxa_Kr_m3 = globalData.System.mapSystemParametrar.BIM_FlödesTaxa_Kr_m3;

  const getVerkningsgradFromVärmeBatterityp = (värmebatteriSystemtyp: string) => {
    if (värmebatteriSystemtyp === "Central vattenburen värme") {
      return G29_VägledandeVerkningsgradVärmekälla;
    } else {
      let vKälla = värmebatteriSystemtyp;
      if (vKälla === "Intern värmepump i ventilationsaggregat") vKälla = "Markvärmepump";
      const energiKällaDataRow = globalData?.Byggnadsdata?.Värmekälla.find((r) => r.Värmekälla === vKälla);
      if (energiKällaDataRow) return energiKällaDataRow.COP;
      else {
        logAndNotifyError("getVerkningsgradFromVärmeBatterityp: Värmekälla saknas för " + vKälla);
        return 1.01;
      }
    }
  };

  const getGradtimmarKyla = (kontrollmättTempRegTilluft: number) => {
    let tempTilluft = Math.min(20, kontrollmättTempRegTilluft);
    tempTilluft = Math.max(15, tempTilluft);
    tempTilluft = Math.floor(tempTilluft);

    const gradtimmarRow = globalData.Gemensamt.gradtimmarKylaPerTabellområdeOchTempTilluft.find(
      (r) => r.Tabellområde === normalårsTemperaturOmråde && r.TempTilluft === tempTilluft
    );

    const remainder = kontrollmättTempRegTilluft - tempTilluft;
    const gradtimmarKyla = gradtimmarRow?.GradtimmarKyla as number;
    const intervall = gradtimmarRow?.Intervall as number;
    const offset = intervall * -remainder;
    const totaltGradtimmarKyla = gradtimmarKyla + offset;

    return totaltGradtimmarKyla;
  };

  const getModuleTemperatureInfo = (modName: string) => {
    const myStickprovs = getStickprovsMätningarFörVärmesystem(modName);
    let uppmättMedeltemperatur = 0;
    let uppmättMintemperatur = 0;
    let uppmättMaxtemperatur = 0;
    if (myStickprovs.length) {
      uppmättMedeltemperatur = myStickprovs.reduce((agg, cur) => agg + cur.uppmättTemperatur, 0.0) / myStickprovs.length;
      uppmättMintemperatur = myStickprovs.reduce((agg, cur) => (cur.uppmättTemperatur < agg ? cur.uppmättTemperatur : agg), Number.MAX_VALUE);
      uppmättMaxtemperatur = myStickprovs.reduce((agg, cur) => (cur.uppmättTemperatur > agg ? cur.uppmättTemperatur : agg), Number.MIN_VALUE);
    }

    const rekommenderadMedelTemperatur = verksamhetDataRow?.RekommenderadMedelTemperatur || NaN;
    const diffUppmättMotRekommenderat = uppmättMedeltemperatur - rekommenderadMedelTemperatur;
    const uppmättTempDiff = uppmättMaxtemperatur - uppmättMintemperatur;

    return {
      tempInfo: { verksamhet, uppmättMedeltemperatur, rekommenderadMedelTemperatur, diffUppmättMotRekommenderat, uppmättTempDiff },
      stickprov: { HögstUppmätt: uppmättMaxtemperatur, LägstUppmätt: uppmättMintemperatur, MedelUppmätt: uppmättMedeltemperatur },
    };
  };

  return {
    G13_ÅrligBruttoAnvändningCentralVärme: G13_ÅrligBruttoAnvändningCentralVärme,
    BIM_ÅrligBruttoTransmission: G15_BruttoEnergiTransmission,
    G15_BruttoAnvändningTransmission: G15_BruttoEnergiTransmission,
    G17_BruttoEnergiVentilation_FTX,
    G17_BruttoEnergiVentilation_FX,
    G17_BruttoEnergiVentilation_s,
    G17_BruttoEnergiVentilation: G17_BruttoEnergiVentilation,
    G19_BruttoEnergiTappvatten: G19_BruttoEnergiTappvatten,
    BIM_Vägledande_VerkninsgradAktuellVärmekälla: G29_VägledandeVerkningsgradVärmekälla,
    BIM_Vägledande_Energitäckningsgrad_Värmekälla: G31_VägledandeEnergitäckningsgradVärmekälla,
    G11_GeografiskJusteringsFaktor: G11_GeografiskJusteringsFaktor,
    G5_kommun: G5_kommun,
    kommun: kommun,
    byggnadArea: byggnadArea,
    nybyggnadsar: nybyggnadsar,
    verksamhet: verksamhet,
    verksamhetInfo: verksamhetDataRow,
    energiKälla: energiKälla,
    värmeKällaInfo: energiKällaDataRow,
    energiSlag: energiSlag,
    normalårsTemperatur: normalårsTemperatur,
    normalårsTemperaturOmråde: normalårsTemperaturOmråde,
    allaZoner: allaBetjäningsområden,
    allaVärmeSystem: allaVarmeSystemNamn,
    allaVentilationsSystem: allaVentilationsSystemNamn,
    getStickprovsMätningarFörVärmesystem,
    BIM_Pumpstopp_UteTemperatur,
    BIM_Schablon_TempOptimeratPumpstopp,
    BIM_Schablon_EnergiKyla,
    BIM_NormalUppvärmningstemperatur,
    BIM_DensitetLuft,
    BIM_Luft_Energimängd,
    BIM_TimmarPerGrad_Värme,
    BIM_GradtimmarVärmeFörOrten,
    BIM_Gradtimmar_Kyla_Orten,
    BIM_BruttoCentralVärme_Ventilation,
    BIM_Brutto_LokalVärmekälla_Ventilation,
    BIM_MedelAvkylning_FJV_SWE,
    BIM_QWtal_FJV_SWE,
    BIM_FlödesTaxa_Kr_m3,
    getVerkningsgradFromVärmeBatterityp,
    getGradtimmarKyla,
    getModuleTemperatureInfo,
  };
};

const dflt = { getBIMHandler };

export default dflt;
